/** Instagram Story — document knowledge definition. Pure data. */
export default {
  id: 'instagram-story',
  name: 'Instagram Story',
  description: 'A full-screen vertical story for time-limited announcements and promotions.',
  purpose: 'Social Engagement & Urgency',
  recommendedSizes: [{ name: 'Story', width: 1080, height: 1920, unit: 'px' }],
  supportedOrientations: ['portrait'],
  supportsMultiplePages: false,
  supportsBleed: false,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: false,
  supportsTables: false,
  supportsPricing: true,
  supportsCTA: true,
  supportsOffers: true,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Hero', 'Text', 'CTA'],
};
